import { render } from "./OverlayContainer.vue?vue&type=template&id=f30ec1b8&ts=true"
import script from "./OverlayContainer.vue?vue&type=script&lang=ts"
export * from "./OverlayContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__